<!-- <section class="px-3 featured">
    <div class="container-fluid">
        <div class = "container">
            <h1>Testimonials</h1>
            <h1>Heading 1</h1>
            <span>Please Like This Pen!</span> 
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque tristique mauris a dui ultricies, eu feugiat ligula aliquam. Donec id mattis mauris. Vivamus non eros neque. Aenean convallis magna id mattis aliquam. Quisque at tellus et ante ultricies facilisis a non tortor. Mauris ut justo volutpat, posuere eros vel, fringilla leo. Maecenas tempus purus nec nisl feugiat, vel maximus tellus pellentesque. In tempus posuere ante a tristique. Ut auctor, turpis ac tempus eleifend, magna risus eleifend ante, vel convallis neque massa tempus libero. Curabitur mollis lorem a massa tempus molestie. Aliquam ante nulla, venenatis eget elementum nec, vehicula vitae metus. Phasellus quis varius urna. Curabitur hendrerit ipsum sed dui porta, quis finibus lectus tincidunt. Maecenas finibus tortor ut est interdum tempus. Vestibulum cursus sapien sodales risus feugiat pharetra.</p>
            <h2>Testimonials:</h2>
            <div class = "testimonials" *ngFor="let test of testimonial">
                <ul>
                    <li>
                        <img [src] = "test.image">
                        <p>{{test.message}}</p>
                        <h1>{{test.name}}</h1>
                    </li>
                
                </ul>
            </div>
            <span style = "display: block; margin: 20px 0 20px 0;">Designed by Tristan Weston Wood.</span>
        </div>
    </div>
  </section> -->
  <!-- <app-loader ></app-loader> -->

<section id="testimonial">
  <!-- top circle border --> 
  <div class="top-rounded-border"></div>



  <div class="container-fluid" id="top-main">
  
      <div class="col-md-12">

        <div class="row">
          <div class="col-lg-8">
            <ol class="breadcrumb px-0 m-0 pb-0">
              <li class="breadcrumb-item">
                <a href="#"><i class="fa fa-home">Home</i></a>
              </li>
              <li class="breadcrumb-item active" aria-current="page"></li>
            </ol>
            <h3 class="mt-4">
            
            </h3>
          </div>
        </div>


        <!--=====================Skeleton Loader======================-->
        <!-- <div class="row mt-3" *ngIf="showLoader">
          <div class="col-lg-3 mt-4">
            <div class="card mb-3 box-shadow">
              <ngx-skeleton-loader
                [theme]="{ height: '255px', width: '100%', 'border-top-right-radius': '25px', 'border-top-left-radius': '25px' }"
                count="1" appearance="line">
              </ngx-skeleton-loader>
              <div class="card-body">
                <ngx-skeleton-loader count="2" appearance="line"> </ngx-skeleton-loader>
              </div>
            </div>
          </div>

          <div class="col-lg-3 mt-4">
            <div class="card mb-3 box-shadow">
              <ngx-skeleton-loader
                [theme]="{ height: '255px', width: '100%', 'border-top-right-radius': '25px', 'border-top-left-radius': '25px' }"
                count="1" appearance="line">
              </ngx-skeleton-loader>
              <div class="card-body">
                <ngx-skeleton-loader count="2" appearance="line"> </ngx-skeleton-loader>
              </div>
            </div>
          </div>

          <div class="col-lg-3 mt-4">
            <div class="card mb-3 box-shadow">
              <ngx-skeleton-loader
                [theme]="{ height: '255px', width: '100%', 'border-top-right-radius': '25px', 'border-top-left-radius': '25px' }"
                count="1" appearance="line">
              </ngx-skeleton-loader>
              <div class="card-body">
                <ngx-skeleton-loader count="2" appearance="line"> </ngx-skeleton-loader>
              </div>
            </div>
          </div>

          <div class="col-lg-3 mt-4">
            <div class="card mb-3 box-shadow">
              <ngx-skeleton-loader
                [theme]="{ height: '255px', width: '100%', 'border-top-right-radius': '25px', 'border-top-left-radius': '25px' }"
                count="1" appearance="line">
              </ngx-skeleton-loader>
              <div class="card-body">
                <ngx-skeleton-loader count="2" appearance="line"> </ngx-skeleton-loader>
              </div>
            </div>
          </div>

          <div class="col-lg-3 mt-4">
            <div class="card mb-3 box-shadow">
              <ngx-skeleton-loader
                [theme]="{ height: '255px', width: '100%', 'border-top-right-radius': '25px', 'border-top-left-radius': '25px' }"
                count="1" appearance="line">
              </ngx-skeleton-loader>
              <div class="card-body">
                <ngx-skeleton-loader count="2" appearance="line"> </ngx-skeleton-loader>
              </div>
            </div>
          </div>

          <div class="col-lg-3 mt-4">
            <div class="card mb-3 box-shadow">
              <ngx-skeleton-loader
                [theme]="{ height: '255px', width: '100%', 'border-top-right-radius': '25px', 'border-top-left-radius': '25px' }"
                count="1" appearance="line">
              </ngx-skeleton-loader>
              
              <div class="card-body">
                <ngx-skeleton-loader count="2" appearance="line"> </ngx-skeleton-loader>
              </div>
            </div>
          </div>
        </div> -->
        <!--=======================Skeleton Loader end==============================-->

        <!-- <ol class="breadcrumb px-0 m-0 pb-0" *ngIf="!categoryName">
          <li class="breadcrumb-item">
            <a href="#"><i class="fa fa-home"> Home</i></a>
          </li>
          <li class="breadcrumb-item" *ngFor="let item of breadcrumb">
            <a routerLink="/category/{{ item.categoryId }}">{{ item.categoryName }}
            </a>
          </li>
          <li class="breadcrumb-item " *ngFor="let item of getdata?.categories">{{item.categoryName}}</li>
        </ol> -->
        <h3 class="title">Testimonials</h3>

        <div class="row"  infiniteScroll [infiniteScrollDistance]="0.1" (scrolled)="onScroll()" [alwaysCallback]='true'  >
            <div class="col-lg-12">
                <div class="card-container">
                    <div class="card" *ngFor = " let test of testimonial ; let i = index">
                        <div class="card-body">
                          <div class="text-center">
                            <img class="card-image" [src]="test.image" alt="">
                          </div>
                       
                         <div class="card-details">
                          <h5 class="card-title">{{test.name}}</h5>
                          <p>{{test.message}}</p>
                         </div>
                          
                          
                        </div>
                      
                        </div>

        <!--gif loader-->
        <div class="text-center" *ngIf="gifLoader">
          <img src="/assets/images/gif-infinite-scroll3.gif" style="height: 100px; width: auto;">
        </div>
                </div>
      
               
            </div>
         

<!-- 
            <div class="col-lg-6">
                <div class="card-container">
                    <div class="card">
                        <div class="card-body">
                            
                         <img class="card-image" src="https://www.whatsappprofiledpimages.com/wp-content/uploads/2021/11/1080p-Whatsapp-Dp-Profile-Images-For-Girl-pictures-free-download.gif" alt="">
                         <div class="card-details">
                          <h5 class="card-title">John doe</h5>
                          <p>With supporting text below as a natural lead-in to additional content.</p>
                         </div>
                          </div>
                        </div>
                        <div class="card">
                            <div class="card-body">
                                
                             <img class="card-image" src="https://www.whatsappimages.in/wp-content/uploads/2021/02/Stylish-Girls-Whatsapp-DP-Images-pics-for-download.gif" alt="">
                             <div class="card-details">
                              <h5 class="card-title">John doe</h5>
                              <p>Jan 21, 2022 - Explore Jaya Gaur's board "Anniversary cake" on Pinterest. See more ideas about happy anniversary wishes, wedding anniversary wishes, ...</p>
                             </div>
                              
                              
                            </div>
                            </div>
                   





                </div>











            </div>

      -->
      </div>
      <!-- <div class="container" >
    <div class="dot"></div>
    <div class="dot"></div>
    <div class="dot"></div>
    <div class="dot"></div>
    <div class="dot"></div>
  </div> -->

    </div>
   
    



    <!---------------sidenav bar---------------->
  
    <!----------------sidenav bar End-------------------->


  </div>
  <div class="whatsapp-icon" style="background-color: #22ce5a">
    <a
      href="https://api.whatsapp.com/send?phone=+918122210222 &amp;text= I'm interested in this product and I have a few questions. Can you help?"
      target="_blank"
    >
      <svg width="25" height="25" viewBox="0 0 25 25" fill="none">
        <path
          d="M10.8039 0.0681698C6.25549 0.756887 2.54823 3.69142 0.901889 7.90756C-0.353895 11.1236 -0.185656 14.8007 1.35253 17.9149L1.71304 18.6396L0.841803 21.8077C0.367129 23.5504 -0.0174167 24.9877 0.00060889 24.9997C0.012626 25.0117 1.48472 24.6404 3.27526 24.1733L6.53188 23.3228L7.19282 23.6343C10.6297 25.2393 14.5833 25.2213 17.9661 23.5804C19.5464 22.8138 20.9704 21.6939 22.13 20.3105C24.1609 17.891 25.2064 14.639 24.9661 11.5069C24.6236 7.04517 22.0039 3.1644 18.0262 1.23C16.8966 0.679031 15.9533 0.3736 14.6314 0.12207C13.9164 -0.00968513 11.555 -0.045618 10.8039 0.0681698ZM14.343 2.18822C15.3164 2.35591 16.2537 2.67332 17.2151 3.15841C18.2906 3.7034 19.0176 4.23041 19.8588 5.06885C21.7875 6.99127 22.797 9.31494 22.9051 12.0459C22.9893 14.3156 22.3463 16.4656 21.0004 18.382C20.4236 19.2085 19.2039 20.3943 18.3567 20.9513C16.5842 22.1311 14.9138 22.6641 12.8288 22.718C10.7018 22.7779 9.13358 22.3766 7.08467 21.2327L6.83832 21.095L4.93962 21.5921C3.90015 21.8676 3.01689 22.0832 2.98685 22.0712C2.95681 22.0592 3.1611 21.2267 3.43749 20.2206C3.70787 19.2145 3.9362 18.3581 3.9362 18.3102C3.9362 18.2623 3.83405 18.0646 3.70186 17.861C2.06754 15.2798 1.68901 11.9321 2.70445 9.02149C3.7259 6.11091 5.95506 3.81718 8.86319 2.69727C9.68636 2.37986 10.5215 2.19421 11.7473 2.05048C12.1979 1.99658 13.676 2.07443 14.343 2.18822Z"
          fill="white"
        />
        <path
          d="M7.81182 6.69762C7.3732 6.8174 6.70626 7.61392 6.39381 8.39247C6.26763 8.70987 6.25562 8.84762 6.25562 9.59023C6.25562 10.4107 6.26162 10.4407 6.47192 11.0216C7.0908 12.6745 8.96546 14.9742 10.8221 16.3636C11.8135 17.1062 12.6908 17.5434 14.1929 18.0465C15.5088 18.4837 16.374 18.4717 17.3353 17.9986C18.0263 17.6572 18.525 17.1601 18.6813 16.6571C18.8315 16.1839 18.8795 15.4653 18.7714 15.3335C18.6031 15.1299 16.0435 13.9321 15.7791 13.9321C15.5748 13.9321 15.5869 13.9202 14.986 14.6748C14.4272 15.3695 14.247 15.5491 14.0847 15.5491C13.8444 15.5491 12.7929 15.0341 12.162 14.6209C11.8435 14.4053 11.3569 14.022 11.0865 13.7704C10.2933 13.0278 9.40409 11.8121 9.40409 11.4707C9.40409 11.3689 9.52426 11.1833 9.77061 10.9018C10.1552 10.4646 10.4255 10.0095 10.4255 9.79984C10.4255 9.68007 9.57232 7.55403 9.344 7.10487C9.28391 6.99108 9.18778 6.85333 9.12769 6.79943C8.98349 6.67367 8.14229 6.60779 7.81182 6.69762Z"
          fill="white"
        />
      </svg>
    </a>
  </div>

</section>




